<template>
    <transition name="slide">
        <div class="elevation" v-if="displayActus && closedFromParent && !isModalChoixPortailOuverte" @click="displayOrHideActus">
            <div class="container-actualites box-shadow" @click.stop>
                <div class='header'>
                    <h3>
                        {{$t('home.actualites.header')}}
                        <ReglePastille cle="dashboard.actualites" placement="bottom" />
                        <ReglePastille cle="dashboard.actualiteLectureAutomatique" placement="bottom" />
                    </h3>
                </div>
                <Carousel :settings="settings" :itemsToShow="1"
                          @slide-start="handleSlideStart"
                          @init="handleInit">

                    <Slide v-for="slide in actualites" :key="slide.id">
                        <div>
                            <img :src="actualitesImagesLocation + slide.nomImage" class="image" alt="image">
                            <div  class="carousel__item">
                                <h2 class="titre">
                                    {{slide.titre}}
                                </h2>
                                <div v-html="slide.contenu" class="texte"></div>
                            </div>
                        </div>
                    </Slide>

                    <template #addons>
                        <Pagination />
                        <Navigation/>
                    </template>
                </Carousel>
                <button class="vertical-button close-button" @click="displayOrHideActus">
                    <img class="close-icon" :src="closeIcon" alt="close" />
                    <div class='close-text'>{{$t('home.actualites.close')}}</div>
                </button>
            </div>
        </div>
        <div v-else>
            <button class="vertical-button open-button" @click="displayOrHideActus">{{$t('home.actualites.open')}}</button>
            <div class="nb-notifications" v-if="nbNouvellesActualites !== 0">{{nbNouvellesActualites}}</div>
        </div>
    </transition>
</template>

<script lang="ts">

import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';
import actualitesService from '@/modules/Actualites/services/ActualitesService';
import { store } from '@/plugins/store';
import { HomeAction } from '@/modules/Home/store/actions-types';
import { Actualite } from '@/models/Actualite';
import { defineComponent, PropType } from 'vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'Actualites',
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
        ReglePastille,
    },
    data() {
      return {
          openModal: false,
          init: false,
          settings: {
              snapAlign: 'center',
          },
      };
    },
    props: {
        actualites: { required: true, type: Array as PropType<Actualite[]> },
    },
    methods: {
        displayOrHideActus(): void {
            this.init = true;
            this.openModal = !this.$store.getters.getActualiteOpen;
            if (!this.openModal) {
                this.actualites.forEach(actu => {
                    if(!actu.dejaConsulte) {
                        store.dispatch(HomeAction.GET_ACTUALITES);
                    }
                });
            }
            store.dispatch(HomeAction.SET_ACTUALITE_OPEN, this.openModal);
        },
        handleSlideStart(data: any): void {
            if(!this.actualites[data.slidingToIndex].dejaConsulte) {
                actualitesService.setActualiteConsulte(this.actualites[data.slidingToIndex].id);
            }
        },
        handleInit(): void {
            this.openModal = true;
            this.init = true;
            store.dispatch(HomeAction.SET_ACTUALITE_OPEN, this.openModal);
            if(!this.actualites[0].dejaConsulte) {
                actualitesService.setActualiteConsulte(this.actualites[0].id);
            }
        },
    },
    computed: {
        closeIcon(): any {
            return require('@/assets/img/close-white.svg');
        },
        nbNouvellesActualites(): number {
            return this.$store.getters.getNbNouvellesActualites;
        },
        openOnStart(): boolean {
            return this.$store.getters.getNbNouvellesActualites !== 0;
        },
        displayActus(): boolean {
            if (!this.init) {
                return this.openOnStart;
            } else {
                return this.openModal;
            }
        },
        actualitesImagesLocation(): string{
            return window.CONFIG.actualitesCommunications;
        },
        closedFromParent() : boolean {
            if (this.$store.getters.getActualiteOpen == undefined) {
                return true;
            } else {
                return this.$store.getters.getActualiteOpen;
            }
        },
        isModalChoixPortailOuverte(): boolean {
            return this.$store.getters.getModalChoixPortailOuverte;
        }
    },
});
</script>

<style scoped>
.container-actualites {
    background-color: var(--white);
    top: 5vh;
    width: 34.3%;
    word-break: break-word;
    border-radius: 5px;
    position: relative;
}
.slide-enter-active{
    transition: all 1.5s;
}
.slide-leave-active {
    transition: all 0.5s;
}
.slide-leave-to {
    transform: translateX(-33%);
}
.slide-enter-to {
    transform: translateX(0);
}
.slide-enter-from {
    transform: translateX(-33%);
}
@media (max-width: 1030px){
    .container-actualites {
        width: 45%;
    }
}
@media (max-width: 740px){
    .container-actualites {
        width: 70%;
    }
}
.vertical-button {
    background-color: var(--bleu-secondaire);
    border: none;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    height: 40px;
    cursor: pointer;
    padding-left: 15px;
    padding-right: 15px;
    color: var(--white);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}
.open-button {
    -webkit-transform: rotate(-90deg) translate(-99%, 50%);
    transform-origin: 0;
    font-size: 20px;
    position: absolute;
    z-index: 1;
    width: 215px;
    top: 11.5vh;
}

.close-button {
    -webkit-transform: rotate(-90deg) translate(0%, 0%);
    position: absolute;
    right: -127px;
    top: 26%;
    width: 213px;
    display: flex;
    justify-content: space-evenly;
}
.close-icon {
    cursor: pointer;
    margin-top: 5px;
}
.close-text {
    display: inline-block;
    float: right;
    margin-top: 5px;
    font-size: 20px;
}
.header {
    padding-left: 15px;
    background-color: var(--header-blue);
    color: var(--white);
    height: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-top-right-radius: 5px;
}
:deep(.carousel__pagination-button--active::after) {
    background-color: var(--header-blue) !important;
}
:deep(.carousel__pagination-button::after) {
    background-color: var(--white);
    border: 1px solid;
    border-color: var(--header-blue);
    border-radius: 50%;
    height: 22px;
    width: 22px;
}
.titre {
    margin-left: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: left;
    padding-left: 5px;
}
:deep(.carousel__slide) {
    justify-content: left;
    text-align: left;
    align-items: initial;
}
:deep(.carousel__prev), :deep(.carousel__next) {
    top: 25%;
    width: 10%;
    height: 10%;
}
:deep(.carousel__icon) {
    width: 100%;
    height: 100%;
}
@media (max-height: 770px) {
    :deep(.carousel__viewport) {
        max-height: 70vh;
    }
    .image {
        height: 150px;
    }
    .close-button{
        top:32%;
    }
}
@media (min-height: 771px) {
    .image {
        height: 250px;
    }
}
.texte {
    margin-left: 15px;
    margin-right: 15px;
    max-height: 30vh;
    overflow: auto;
}
.image {
    display: block;
    margin: 10px auto;
}
.nb-notifications {
    background-color: var(--red);
    z-index: 7;
    position: absolute;
    border-radius: 50%;
    color: var(--white);
    text-align: center;
    width: 20px;
    top: 12vh;
    left: 30px;
}
.box-shadow{
    box-shadow: 0 -3px 5px rgba(0, 0, 0, 0.25), 3px 3px 6px rgba(0, 0, 0, 0.25);
}
.elevation {
    margin-top: -3vh;
    width: 96%;
    z-index: 9 !important;
}
</style>
